import ExlyTable from "common/Components/ExlyTable";
import React, { useEffect } from "react";
import { RESOURCE_KEYS, orgPermissions } from "utils/OrgPermissions";
import {
  filterConfig,
  getTableConfig,
  tableChipsFormatter,
} from "./refundTableConfig";
import { exportLargeListingData } from "utils/Utils";
import { REPORT_TYPES } from "ui/pages/Reports/constants";
import { useNotifications } from "utils/hooks";
import { is_empty } from "utils/validations";
import { WhatsAppButton } from "webpage-leads/components/CustomColumns";
import {
  FilteredEmptyState,
  StatusField,
} from "../AllTransaction/components/TableFields/TableFields";
import { emptyStateProps } from "./refund.constant";
import { useIsRefundEnabled } from "../AllTransaction/utils/AllTransaction.util";
import { RefundHistoryVerificationStates } from "features/Transactions/modules/RefundHistory/modules/RefundHistoryVerificationStates/RefundHistoryVerificationStates";
import { useRefundHistoryVerificationStates } from "features/Transactions/modules/RefundHistory/modules/RefundHistoryVerificationStates/utils/useRefundHistoryVerificationStates";
import { getTransactionsTabConfig } from "features/Crm/modules/Transactions/utils/Transactions.utils";

const RefundHistory = (props) => {
  const { notify } = useNotifications();
  const isCustomerDetailsHidden = orgPermissions.isNavigationItemHidden(
    RESOURCE_KEYS.SECTIONS.ALL_CUSTOMERS
  );

  const { isRefundEnabled } = useIsRefundEnabled();
  const { fetchRefundHistoryVerificationStates } =
    useRefundHistoryVerificationStates();

  useEffect(() => {
    fetchRefundHistoryVerificationStates();
  }, []);
  const customEmptyStateComponent = <RefundHistoryVerificationStates />;

  return (
    <div className="component-wrapper">
      <ExlyTable
        ra_props={{
          ...props,
        }}
        forceEmptyState={!isRefundEnabled}
        noExportButton={!orgPermissions.canExport()}
        tableTitle="Refund History"
        tabConfig={getTransactionsTabConfig()}
        selectedTab="refund-history"
        columnConfig={getTableConfig}
        tableChipsFormatter={tableChipsFormatter()}
        layoutProps={{
          paddingDesktop: "0",
          paddingMobile: "0",
          paddingBottom: "68px",
          noMobileBoxShadow: true,
          showFixedBars: true,
        }}
        customHandleExport={({ filterValues, isEmpty }) =>
          exportLargeListingData({
            filterValues,
            reportType: REPORT_TYPES.REFUND_HISTORY,
            notify,
            isEmpty,
          })
        }
        renderPrimaryColumnRightNode={(record) => {
          return (
            <>
              {is_empty(record.customer_phone) ||
              isCustomerDetailsHidden ? null : (
                <WhatsAppButton
                  record={record}
                  source="customer_phone"
                  countryCodeKey="country_code"
                />
              )}
            </>
          );
        }}
        filteredEmptyState={<FilteredEmptyState />}
        borderedFields
        fieldsLeftPadded
        drawerFieldsBordered
        fieldsAlignment="space-between"
        drawerFieldsAlignment="space-between"
        recordFooterVariant="secondary"
        renderSecondaryAction={(record) => <StatusField record={record} />}
        tableFilters={filterConfig()}
        {...(!isRefundEnabled
          ? { customEmptyState: customEmptyStateComponent }
          : emptyStateProps)}
      />
    </div>
  );
};

export default RefundHistory;
